module.exports = {
      id: "default-author-usage",
      viewBox: "0 0 122 120",
      url: __webpack_public_path__ + "svg-sprite-5579a9c22c9b0e56875750544888299d.svg#default-author",
      toString: function () {
        return this.url;
      }
    }